import type { SplitExperimentVariant } from '@/hooks/useSplitExperiment'
import { SPLIT_EXPERIMENT_VARIANTS } from '@/hooks/useSplitExperiment'

export const getMenuItemExperimentTitle = (
  controlTitle: string,
  variantTitle: string,
  variantName: SplitExperimentVariant
) =>
  variantName === SPLIT_EXPERIMENT_VARIANTS.VARIANT
    ? variantTitle
    : controlTitle

export const getManualExperimentExposureDeduplicationKey = ({
  experimentName,
  pocId,
  variantName,
}: {
  experimentName: string
  pocId?: number
  variantName: string
}) => {
  if (!pocId) return undefined

  return `manual_experiment_exposure:${experimentName}:${pocId}:${variantName}`
}
